/**
 * Supabase client configuration.
 *
 * These are PUBLIC client credentials by design (Supabase anon/publishable
 * keys ship in every browser bundle; row level security is the actual
 * security boundary — see supabase/migrations/0001_saves.sql). Committing
 * them is intentional and keeps "all project state in the repo".
 *
 * Override per environment via Vite env if needed:
 *   VITE_SUPABASE_URL / VITE_SUPABASE_KEY
 * (the owner's dashboard shows them as NEXT_PUBLIC_* — same values).
 */

export interface SupabaseConfig {
  url: string;
  /** Publishable (or legacy anon) key. */
  key: string;
}

const DEFAULT_URL = 'https://dturpghrgrozamxlqclb.supabase.co';
const DEFAULT_KEY = 'sb_publishable_lZ35iG_wuDdQZdiOPJ6BcQ_vgboYpO5';

export function getSupabaseConfig(): SupabaseConfig | null {
  const env = (import.meta as { env?: Record<string, string | undefined> }).env ?? {};
  const url = env.VITE_SUPABASE_URL ?? DEFAULT_URL;
  const key = env.VITE_SUPABASE_KEY ?? DEFAULT_KEY;
  if (!url || !key) return null;
  return { url, key };
}
